import { PermissionAppointments } from "../shared/models/appointment.permission.model";
import { SinglePermissionModel } from "../shared/models/IPermission";
import { MapSinglePermissionModelToPermissionAdmin } from "../shared/mapper/single-permission-model-to-permission-admin.mapper";
import { UserPermissions } from "../../../shared/enums/permissionType"

export function getViewModleForPermissions(model: SinglePermissionModel[],/* isEditingMode: boolean,*/ viewMode: number /*= ViewPermission.FullAccess*/, groupPermission?: number[]): PermissionAppointments {
    let permissionAppointments = new PermissionAppointments();
    // Question: Should use enums?
    let appointmentView = model.find(p => p?.permissionId === 35);
    let appEdit = model.find(p => p?.permissionId === 36);
    let appDel = model.find(p => p?.permissionId === 37);
    let ExAdd = model.find(p => p?.permissionId === 38);
    let ExEdit = model.find(p => p?.permissionId === 39);
    let ExEdDel = model.find(p => p?.permissionId === 40);

    permissionAppointments.selectAllPermissionAppointments=
    {
        Selected:true,
        Enabled:true,
        Id:999,
        DisplayName:''
    }
    
    permissionAppointments.Appointements = {
      selectAll: false,

      appointmentsView: MapSinglePermissionModelToPermissionAdmin(appointmentView, 35, viewMode, groupPermission),

    

    appointmentsEdit: MapSinglePermissionModelToPermissionAdmin(appEdit, 36, viewMode, groupPermission),


    appointmentsDelete: MapSinglePermissionModelToPermissionAdmin(appDel, 37, viewMode, groupPermission),


    ExceptionsAdd: MapSinglePermissionModelToPermissionAdmin(ExAdd, 38, viewMode, groupPermission),


    ExceptionsEdit: MapSinglePermissionModelToPermissionAdmin(ExEdit, 39, viewMode, groupPermission),


    ExceptionsDelete: MapSinglePermissionModelToPermissionAdmin(ExEdDel, 40, viewMode, groupPermission),

    appointmentsAdd: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['Add Appointments']), UserPermissions['Add Appointments'], viewMode, groupPermission)

    }


    permissionAppointments.ViewActionCenter = {
      selectAll: false,

      viewActionCenter: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['View Action Center']), UserPermissions['View Action Center'], viewMode, groupPermission),

      editActionCenter: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['Edit Action Center']), UserPermissions['Edit Action Center'], viewMode, groupPermission),

      changeAppointmentAssignment: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['Change Appointment Assignment']), UserPermissions['Change Appointment Assignment'], viewMode, groupPermission),

      sendFollowUpEnable: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['Send Follow Up Emails']), UserPermissions['Send Follow Up Emails'], viewMode, groupPermission),

      bulkDeleteAppointments: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['Bulk Delete Appointment']), UserPermissions['Bulk Delete Appointment'], viewMode, groupPermission),

      changeAppointmentStatus:  MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['Change Appointment Status']), UserPermissions['Change Appointment Status'], viewMode, groupPermission),

      isInputValid: true
    }

    let viewSystemSettings = model.find(p => p?.permissionId === 1);
    let editSysteSetting = model.find(p => p?.permissionId === 1);

    permissionAppointments.SystemSettings = {
      selectAll: false,

      viewSystemSettings: MapSinglePermissionModelToPermissionAdmin(viewSystemSettings, 1, viewMode, groupPermission),


    editSystemSettings: MapSinglePermissionModelToPermissionAdmin(editSysteSetting, 2, viewMode, groupPermission),
    

    }

    permissionAppointments.Reports = {
      selectAll: false,

      viewAppointmentDetailsReport:  MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['View Appointment Details Report']), UserPermissions['View Appointment Details Report'], viewMode, groupPermission),

      viewCampaignSummaryReport: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['View Campaign Summary Report']), UserPermissions['View Campaign Summary Report'], viewMode, groupPermission),

      viewAppointmentTrendsReport:  MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['View Appointment Trends Report']), UserPermissions['View Appointment Trends Report'], viewMode, groupPermission)
    }

    permissionAppointments.Administration = {
      selectAll: false,
      ViewEditAdministration: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['View/Edit Administration']), UserPermissions['View/Edit Administration'], viewMode, groupPermission),
      ViewEditEventSettings: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['View/Edit Event Settings']), UserPermissions['View/Edit Event Settings'], viewMode, groupPermission)
    }

    permissionAppointments.Campaigns = {
      selectAll: false,
      ViewCampaigns: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['View Campaigns']), UserPermissions['View Campaigns'], viewMode, groupPermission),
      AddCampaigns: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['Add Campaigns']), UserPermissions['Add Campaigns'], viewMode, groupPermission),
      EditCampaigns: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['Edit Campaigns']), UserPermissions['Edit Campaigns'], viewMode, groupPermission),
      DeleteCampaigns: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['Delete Campaigns']), UserPermissions['Delete Campaigns'], viewMode, groupPermission)
    }

    permissionAppointments.Events = {
      selectAll: false,
      ViewEvents: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['View Events']), UserPermissions['View Events'], viewMode, groupPermission),
      AddEvents: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['Add Events']), UserPermissions['Add Events'], viewMode, groupPermission),
      EditEvents: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['Edit Events']), UserPermissions['Edit Events'], viewMode, groupPermission),
      ActivateDeactivateEvents: MapSinglePermissionModelToPermissionAdmin(model.find(p => p?.permissionId === UserPermissions['Activate/Deactivate Events']), UserPermissions['Activate/Deactivate Events'], viewMode, groupPermission)
    }

    return permissionAppointments;
  }

  export function setSelectAllAppointmentStatus(permissionAppointments: PermissionAppointments): boolean {
    let enabled = checkAppointmentAdminStatus(permissionAppointments)
                && checkAppointmentStatus(permissionAppointments)
                && checkAppointmentActionStatus(permissionAppointments)
                && checkAppointmentCampaignStatus(permissionAppointments)
                && checkAppointmentEventStatus(permissionAppointments)
                && checkAppointmentReportStatus(permissionAppointments)

    return enabled;
  }

  //Check for disabled and un-check fields in each sub category of appointments permissions section

function checkAppointmentAdminStatus(permissionAppointments: PermissionAppointments): boolean {

  let enabled = false;

  let ViewEditAdministration = !permissionAppointments.Administration.ViewEditAdministration.Enabled;
  let ViewEditEventSettings = !permissionAppointments.Administration.ViewEditEventSettings.Enabled;

  if (ViewEditAdministration || ViewEditEventSettings) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkAppointmentStatus(permissionAppointments: PermissionAppointments): boolean {

  let enabled = false;

  let appointmentsView = !permissionAppointments.Appointements.appointmentsView.Enabled;
  let appointmentsAdd = !permissionAppointments.Appointements.appointmentsAdd.Enabled;
  let appointmentsEdit = !permissionAppointments.Appointements.appointmentsEdit.Enabled;
  let appointmentsDelete = !permissionAppointments.Appointements.appointmentsDelete.Enabled;
  let ExceptionsAdd = !permissionAppointments.Appointements.ExceptionsAdd.Enabled;
  let ExceptionsEdit = !permissionAppointments.Appointements.ExceptionsEdit.Enabled;
  let ExceptionsDelete = !permissionAppointments.Appointements.ExceptionsDelete.Enabled;

  if (appointmentsView || appointmentsAdd || appointmentsEdit || appointmentsDelete || ExceptionsAdd || ExceptionsEdit || ExceptionsDelete) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkAppointmentActionStatus(permissionAppointments: PermissionAppointments): boolean {

  let enabled = false;

  let viewActionCenter = !permissionAppointments.ViewActionCenter.viewActionCenter.Enabled;
  let editActionCenter = !permissionAppointments.ViewActionCenter.editActionCenter.Enabled;
  let bulkDeleteAppointments = !permissionAppointments.ViewActionCenter.bulkDeleteAppointments.Enabled;
  let changeAppointmentAssignment = !permissionAppointments.ViewActionCenter.changeAppointmentAssignment.Enabled;
  let changeAppointmentStatus = !permissionAppointments.ViewActionCenter.changeAppointmentStatus.Enabled;
  let sendFollowUpEnable = !permissionAppointments.ViewActionCenter.sendFollowUpEnable.Enabled;

  if (viewActionCenter || editActionCenter || bulkDeleteAppointments || changeAppointmentAssignment || changeAppointmentStatus || sendFollowUpEnable) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkAppointmentCampaignStatus(permissionAppointments: PermissionAppointments): boolean {

  let enabled = false;

  let ViewCampaigns = !permissionAppointments.Campaigns.ViewCampaigns.Enabled;
  let EditCampaigns = !permissionAppointments.Campaigns.EditCampaigns.Enabled;

  if (ViewCampaigns  || EditCampaigns) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkAppointmentEventStatus(permissionAppointments: PermissionAppointments): boolean {

  let enabled = false;

  let ViewEvents = !permissionAppointments.Events.ViewEvents.Enabled;
  let AddEvents = !permissionAppointments.Events.AddEvents.Enabled;
  let EditEvents = !permissionAppointments.Events.EditEvents.Enabled;
  let ActivateDeactivateEvents = !permissionAppointments.Events.ActivateDeactivateEvents.Enabled;

  if (ViewEvents || AddEvents || EditEvents || ActivateDeactivateEvents) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkAppointmentReportStatus(permissionAppointments: PermissionAppointments): boolean {

  let enabled = false;

  let viewAppointmentDetailsReport = !permissionAppointments.Reports.viewAppointmentDetailsReport.Enabled;
  let viewAppointmentTrendsReport = !permissionAppointments.Reports.viewAppointmentTrendsReport.Enabled;
  let viewCampaignSummaryReport = !permissionAppointments.Reports.viewCampaignSummaryReport.Enabled;

  if (viewAppointmentDetailsReport || viewAppointmentTrendsReport || viewCampaignSummaryReport) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}